// extracted by mini-css-extract-plugin
export default {"spinner":"AgenciesCreationForm_spinner__Ej3h2","createForm":"AgenciesCreationForm_createForm__PB8RC","actions":"AgenciesCreationForm_actions__9dB8i"};